export default __webpack_public_path__ + "static/five-bfa35729f496df5ffab479931f79c69f.jpg";